import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
import HeaderTop from '../../../components/HeaderTop'
import Breadcumb from '../../../components/Breadcumb'
import TeamMember from '../../../components/TeamMember'
import NewsLetter from '../../../components/Newsletter'
import FooterArea from '../../../components/FooterArea'
// images
import breadcumb from '../../../images/breadcumb/1.jpg'

import './style.scss'
import HeroSlider from "../../../components/HeroSlider";

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Our Team' }
]

const TeamPage = () => {
    return (
        <Fragment>
             <header className="headerArea">
                <HeaderBotton className="headerBottomArea" />
            </header>
            <Breadcumb
                className="breadcumbArea"
                title="Our Team"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />
             <TeamMember
                id="team-member"
                title="Servicios"
                infoTeam="Retira tu AFORE por desempleo de forma rápida y sin complicaciones.
HASTA $35,500.00"
                className="teamArea"
                slider={true}
            />

            <FooterArea />
        </Fragment>
    )
}
export default TeamPage